<template>
  <div v-if="showDialog" class="mask">
    <div class="iframe-wrap">
      <!-- <object :data="fileUrl" type="application/pdf" width="100%" height="100%">
        <iframe :src="fileUrl" width="100%" height="100%" style="border: none;">
          <embed
          :src="fileUrl"
          type="application/pdf"
          width="100%"
          height="100%"
          />
          This browser does not support PDFs. Please download the PDF to view
          it:
        </iframe>
      </object> -->
      <iframe
        :src="`/pdfjs/web/viewer.html?file=${encodeURIComponent(fileUrl)}`"
        frameborder="0"
        class="frame"
      >
      </iframe>
    </div>

    <!-- <div class="iframe-wrap">
      <iframe class="frame" :src="fileUrl" frameborder="0"></iframe>
    </div> -->

    <div class="close-btn">
      <el-button icon="el-icon-close" circle @click="closeMask" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'FilePreview',

  model: {
    prop: 'showDialog',
    event: 'change'
  },

  props: {
    showDialog: {
      type: Boolean,
      required: true
    },
    fileUrl: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      baseUrl: process.env.BASE_URL
    }
  },

  methods: {
    closeMask() {
      this.$emit('change', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 10000;

  .iframe-wrap {
    margin: 0 auto;
    width: 1000px;
    height: 100%;

    .frame {
      width: 100%;
      height: 100%;
    }
  }

  .close-btn {
    position: absolute;
    top: 50px;
    right: 50px;
  }
}
</style>
